const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET)

export const apiPriceDiets = {
	updatePriceDiets: async (dietId: number, payload: IPriceDietMealPayload[]) => {
		const { data } = await apiCommon<IPriceDietMeal[]>(`${groupPrefix}/${dietId}/prices`, {
			method: 'PUT',
			body: { prices: payload },
		})
		return { data: data.map(d => PriceDiet(d)) }
	},
}
